module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/can-vux-used-in-weapp-49.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/faq/can-vux-used-in-weapp.md
// module id = 889
// module chunks = 605